import moment from "moment-timezone";
import ListService from "@/api/sosList";

const state = {
    List: [],
    interval: 5, // mins
}
const getters = {
    List: state => state.List,
    getSelectedFacility: (state, getters, rootState) => {
        return rootState.selectedFacility;
    },

}
const actions = {
    async list({ commit }) {

        const response = await ListService.getList();
        response.data = response.data.map((dt) => {
            return {
                ...dt,
                data: {
                    ...dt,
                    dateTime: moment(dt.timeStamp).format('DD/MM/YYYY hh:mm A')
                }
            }
        });
        console.log('Resuting : ',response.data );
        commit('ListDisplay', response);
    },
    async AckgnowlgList({ dispatch }, data) {
        try {
            await ListService.updateList(data);
            await dispatch("fetchSosCount");
            // commit('AckgnowlgList', data);
        } catch (error) {
            console.error(error);
        }
    },
    async fetchSosCount({ commit }) {
        try {
            const res = await ListService.getSosCount();
            commit("setSosCount", res.data, { root: true });
        } catch (error) {
            console.error(error);
        }
    },
    startTimer({ state, dispatch }) {
        // converting mins to miliseconds
        const interval = state.interval * 60 * 1000;
        setInterval(() => {
            dispatch("fetchSosCount");
        }, interval);
    },
}
const mutations = {
    // AckgnowlgList(state, data) {
    //     console.log(data);
    //     let list = state.List
    //     data.forEach(dt => {
    //         const index = list.map(item => item.id).indexOf(dt.Id);
    //         list.splice(index, 1);
    //     })
    // },
    ListDisplay(state, data) {

        if (data.data != 'SOS data not available') {
            // console.log('Resulting : ',data);
            state.List = data.data
        }
        else {
            state.List = []
        }
    }


}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}